import React from "react";
import styled from "styled-components";
import { scrollPercentage } from "../../../lib/dom/scroll";
import { device } from "../../../helpers/style";

const Container = styled.div`
    z-index: 10000;
    position: fixed;
    display: none;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 5px;
    background-color: #dcdcdc;

    @media ${device.phone} {
        display: block;
    }
`;
const Amount = styled.div<{ percentage: number }>`
    width: ${(p) => p.percentage}%;
    height: 1px;
    border-top: 5px solid #34a962;
    transition: all 0.1s linear;
`;

export default class PercentageRead extends React.Component {
    state = {
        percentage: scrollPercentage(),
    };

    componentDidMount() {
        window.addEventListener("scroll", this.onScroll);
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.onScroll);
    }

    onScroll = () => {
        this.setState({ percentage: scrollPercentage() });
    };

    render() {
        return (
            <Container>
                <Amount percentage={this.state.percentage} />
            </Container>
        );
    }
}
